<template>
  <div class="padded">
    <el-row align="middle">
      <h2><small>Panduan Pengguna</small></h2>
    </el-row>

  <el-row type="flex" justify="start" align="top">

    <el-col :span="4" align="left">

      <el-menu
        v-model="menu"
        :unique-opened="true"
        @select="onClick">
<!--
background-color="#EBEEF5"
text-color="#909399"
active-text-color="#E6A23C"
-->
    <el-menu-item
            v-for="(item, index) in contents"
            v-if="item.visible && !item.children"
            :key="item.key"
            :index="'' + index">
              <template #title>
                <i :class="item.icon ? 'text-warning fa fa-' + item.icon : ''"></i>
                <b>{{isDesktop || isTablet ? item.title : ''}}</b>
              </template>

        </el-menu-item>
        <el-submenu
            v-for="(item, index) in contents"
            v-if="item.visible && item.children"
            :key="item.key"
            :index="'' + index">
              <template #title>
                <i :class="item.icon ? 'text-warning fa fa-' + item.icon : ''"></i>
                <b>{{item.title}}</b>
              </template>

              <el-menu-item
                  v-for="(sub, ind2) of item.children"
                  v-if="sub.visible"
                  :index="sub.key"
                  :disabled="sub.disabled"
                  :key="sub.key">

                <i :class="sub.icon ? 'text-muted fa fa-' + sub.icon : ''"></i>
                <span>{{sub.title}}</span>

              </el-menu-item>
        </el-submenu>


    </el-menu>

    </el-col>

    <el-col>
      <div class="padded">
        <pdf-viewer :url="url" :show-rotate="false" show-page-numbers-bottom />
      </div>
    </el-col>
  </el-row>


  </div>
</template>

<script>

import PdfViewer from '@/components/atoms/PdfViewer'

export default {

  components: {
    PdfViewer
  },

  props: {
    lang: {
      type: String,
      default: 'EN'
    }
  },

  methods: {
    onClick (item, path, data) {
      this.url = this.contents[item].url
    }
  },

  watch: {
    url: function (url) {
      this.url = url
    }
  },

  data () {
    return {
      menu: this.isTelco() ? '0-tel' : '0-intro',
      url: null,
      contents: [
        {key: '0-intro',
          title: 'Pengenalan',
          icon: 'info',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-intro-MS_v2.0_V4Z_l3ygJB.pdf',
          visible: this.isTowerCo()
        },
        {key: '0-tel',
          title: 'Pandangan',
          icon: 'phone',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-telco-MS_RE-7yZY6d.pdf',
          visible: this.isTelco() || this.canAccess('project|maintenance|finance|management')
        },
        {key: '0-main',
          title: 'Menu Utama',
          icon: 'compass',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-menu-MS_v2.0_DByVTK8vA_p.pdf',
          visible: this.isTowerCo()
        },
        {key: '0-dash',
          title: 'Papan pemuka',
          icon: 'chart-pie',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-dashboards-MS_v2.0_eeoyrYcfXGs.pdf',
          visible: this.isTowerCo()
        },
        {key: '0-proj',
          title: 'Projek',
          icon: 'tools',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-project-MS_v2.0_jBgzPeHn7t8.pdf',
          visible: this.isTowerCo() && this.canAccess('maintenance|project|management')
        },
        {key: '0-maint',
          title: 'Penyelenggaraan',
          icon: 'tools',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-maint-MS_v2.0_K-wMjoHIBN.pdf',
          visible: this.isTowerCo() && this.canAccess('maintenance|project|management')
        },
        {key: '0-prop',
          title: 'Penyewaan',
          icon: 'home',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-tenancy-MS_v2.0_9OzzhCARIr.pdf',
          visible: this.isTowerCo() && this.canAccess('property|finance|management')
        },
        {key: '0-fin',
          title: 'Kewangan',
          icon: 'money-bill-alt',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-finance-MY_1m6to2-q7.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1662971624206',
          visible: this.isTowerCo() && this.canAccess('finance|management')
        },
        {key: '0-ops',
          title: 'Operasi',
          icon: 'users-cog',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-admin-MS_v2.0_rJNmBLvfpa.pdf',
          visible: this.isTowerCo() && this.canAccess('project|maintenance|property|finance|admin|management')
        },
        {key: '0-appendix-a',
          title: 'Lampiran A',
          icon: 'cogs',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-appendix-A-MS_M8BAUYeA6.pdf',
          visible: this.isTowerCo() && this.canAccess('project|maintenance|finance|management')
        },
        {key: '0-appendix-b',
          title: 'Lampiran B',
          icon: 'map-pin',
          url: 'https://ik.imagekit.io/91mmj17mvah/xolas-manual/MS/xolas-tms-appendix-B-MS_HCG8ZVoDNX4.pdf',
          visible: this.isTowerCo() && this.canAccess('project|finance|property|admin|management')
        }
      ]
    }
  },

  created () {
    this.url = this.isTelco() ? this.contents[1].url : this.contents[0].url
  }
}
</script>
